<template>
  <div class="main-width pb-10">
    <div class="mt-5 mb-10">
      <VBreadcrumb :options="[{ label: '首页', to: '/' }, {label: '公司介绍'}]"></VBreadcrumb>
    </div>
    <v-loading :active="isLoading"></v-loading>
    <div class="w-[680px] h-[385px] mx-auto">
      <VPlayer :src="state.video?.url" :cover="state.video?.cover"></VPlayer>
    </div>
    <div v-html="state.introduce" class="text-[#1F2129] mt-10" style="text-indent: 28px"></div>
    <div class="flex items-center justify-center w-full mt-11 mb-7">
      <div class="w-20 h-[2px] left-line"></div>
      <div class="text-dark text-[24px] font-medium mx-3">我们的荣誉</div>
      <div class="w-20 h-[2px] right-line"></div>
    </div>
    <div class="bg-[#F8F8F8] px-5 p-5 flex items-center flex-wrap">
      <div v-for="item in state.honor" class="text-center common my-6">
        <el-image
          style="width: 228px; height: 160px"
          :src="item.url"
          fit="scale-down"></el-image>
        <div class="mx-auto mt-6 text-[#606370]">
          <!-- <div v-if="item.name === '中国旅游大奖优选旅游交通'" class="w-[96px] m-auto">
            {{ item.name }}
          </div>
          <div v-else-if="item.name === '交通运输协会邮轮游艇分会常务理事单位' || item.name === '吉林市旅游高质量发展平台成员单位'" class="w-[192px] m-auto">
            {{ item.name }}
          </div>
          <div v-else-if="item.name === '飞猪旅行双11创新合作伙伴' || item.name === '世纪游轮钻石级合作伙伴' || item.name === '蓝梦邮轮官方指定合作代理'">
            {{ item.name.substring(0, 4) }}<br>{{ item.name.substring(4, item.name.length) }}
          </div>
          <div v-else-if="item.name === '长江探索号年度战略合作伙伴' || item.name === '招商伊敦号年度销售-千岩竞秀奖'">
            {{ item.name.substring(0, 5) }}<br>{{ item.name.substring(5, item.name.length) }}
          </div>
          <div v-else-if="item.name === '皇家加勒比国际游轮官方指定合作代理'" class="w-[144px] m-auto">
            {{ item.name }}
          </div>
          <div v-else-if="item.name === '爱达邮轮有限公司官方指定合作代理'" class="w-[128px] m-auto">
            {{ item.name }}
          </div>
          <div v-else-if="item.name === 'Club Med钻石合作伙伴'">
            {{ item.name.substring(0, 8) }}<br>{{ item.name.substring(8, item.name.length) }}
          </div> -->
          <div class="whitespace-pre-wrap"  v-html="item.name"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useFetch, useMeta, defineComponent } from "@nuxtjs/composition-api";
import VBreadcrumb from '@/components/VBreadcrumb.vue';
import VPlayer from "@/components/VPlayer/index.vue";
import { getIntroduce } from "~/services/common";
import useRequest from "@/composables/useRequest";
import { Video } from '@vime/vue';

export default defineComponent({
  layout: "Main",
  auth: false,
  head: {
    title: "公司介绍",
  },
  components: { VBreadcrumb, VPlayer, Video },
  setup() {
    const { execute, state, isLoading } = useRequest(
      getIntroduce,
      {
        video: {},
        honor: [],
        introduce: ""
      },
      { immediate: false }
    );
    useFetch(async () => {
			try {
				await execute(0);
        state.value.honor = state.value.honor.map(item=>{
          let tempName = item.name;
          switch(item.name){
            case '中国旅游大奖优选旅游交通':
              tempName = insertStringBr(item.name,6);
            break;
            case '交通运输协会邮轮游艇分会常务理事单位':
            case '吉林市旅游高质量发展平台成员单位':
              tempName = insertStringBr(item.name,12);
            break;
            case '飞猪旅行双11创新合作伙伴':
            case '世纪游轮钻石级合作伙伴':
            case '蓝梦邮轮官方指定合作代理':
              tempName = insertStringBr(item.name,4);
            break;
            case '长江探索号年度战略合作伙伴':
            case '招商伊敦号年度销售-千岩竞秀奖':
              tempName = insertStringBr(item.name,5);
            break;
            case '皇家加勒比国际游轮官方指定合作代理':
              tempName = insertStringBr(item.name,9);
            break;
            case '爱达邮轮有限公司官方指定合作代理':
            case 'Club Med钻石合作伙伴':
            case '中国旅游车船协会旅游出行行业创新及服务精品案例':
            case 'Age Club老年文旅美好生活创新大奖':
              tempName = insertStringBr(item.name,8);
            break;
            case '中国文旅年度优选案例优选旅行社品牌':
              tempName = insertStringBr(item.name,10);
            break;

          }
          return {
            ...item,
            name: tempName
          }
        })

			} catch (error) {
				console.error(error);
			}
		});

    const insertStringBr = (originalString,index)=>{
      return originalString.substring(0, index) + '\n' + originalString.substring(index);
    }

    return { state, isLoading }
  }
})
</script>

<style lang="scss" scoped>

.common {
  height: 232px;
  width: 290px;
}
.left-line {
  background: linear-gradient(270deg, #005EDC 0%, rgba(0,94,220,0) 100%);
}
.right-line {
  background: linear-gradient(90deg, #005EDC 0%, rgba(0,94,220,0) 100%);
}

</style>
